import { formatDateDisplay, formatFullTimeDisplay } from "@utils/dateFormatter";
import cx from "classnames";
import React from "react";
import styles from "./InputDatePicker.module.scss";
import gstyles from "@gstyles/index";

const View = React.forwardRef(
  (
    {
      onClick,
      date,
      field,
      placeholder = "",
      format = "default",
      dark = false,
      required,
      meta,
    }: any,
    _ref: any
  ) => {
    const handler: any = {
      default: (date: any) => {
        field.value = date ? formatDateDisplay(date) : "";
      },
      fullDate: (date: any) => {
        field.value = date ? formatFullTimeDisplay(date) : "";
      },
    };

    if (handler[format]) {
      handler[format](date);
    }
    return (
      <div
        className={cx(styles.group, {
          [styles.valid]: !!date,
        })}
        onClick={onClick}
      >
        <input {...field} readOnly className={cx({ [styles.dark]: dark })} />
        {gstyles.icons({
          className: styles.suffix,
          name: "calendar-outline",
          size: 22,
          color: "#f7eedf",
        })}
        <span className={styles.highlight} />
        <span className={styles.bar} />
        <label className={cx({ [styles.dark]: dark })}>
          {placeholder}
          {required && <span className={styles.required}>*</span>}
        </label>
        {meta.touched && meta.error && (
          <div className={styles.error}>{meta.error}</div>
        )}
      </div>
    );
  }
);
View.displayName = "InputDatePicker";
export default View;
